module.exports = __webpack_public_path__ + "static/media/imageIcon.524b5713.svg";